"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var hasSegment = function hasSegment() {
  return window && window.analytics;
};
var getSegment = function getSegment() {
  return window.analytics;
};
var withSegment = function withSegment(cb) {
  return function () {
    return !hasSegment() ? null : cb.apply(void 0, arguments);
  };
};
var identifyUser = withSegment(function (user) {
  var additionalInformation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var userId = user && (user.id || user.email);
  if (!userId) {
    getSegment().identify(_objectSpread(_objectSpread({}, user || {}), additionalInformation));
  } else {
    getSegment().identify(userId, _objectSpread(_objectSpread({}, user), additionalInformation));
  }
});
var trackPageChanged = withSegment(function () {
  return getSegment().page();
});
var trackEvent = withSegment(function () {
  var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var user = arguments.length > 1 ? arguments[1] : undefined;
  var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var userProps = !user ? {} : {
    user_id: user.id
  };
  getSegment().track(eventName, _objectSpread(_objectSpread({}, userProps), properties));
});
var _default = {
  identifyUser: identifyUser,
  trackPageChanged: trackPageChanged,
  trackEvent: trackEvent
};
exports.default = _default;
//# sourceMappingURL=SegmentConnector.js.map